import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import { GetDepartmentsUseCase } from 'src/app/core/services/location/domain/usecases/get-departments.usecase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { Failure } from 'src/app/core/utils/failure';

import { UserData } from 'src/app/features/user/domain/entities/user-data.entity';
import { GetAllConciliatorsUseCase } from 'src/app/features/user/domain/usecases/get-all-conciliators.usecase';
import { Departament } from 'src/app/features/user/presentation/components/New-User-SuperAdmin/newUser.component';
import { AudienceFilterModel } from '../../../data/models/audience-filter.model';
import { FilterServiceService } from '../../../services/filter-service.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CalendarTranslationService } from 'src/app/core/services/translate-calendar.service';

@Component({
  selector: 'app-audience-filter',
  templateUrl: './audience-filter.component.html',
  styleUrls: ['./audience-filter.component.css'],
})
export class AudienceFilterComponent implements OnInit {
  departmentList: Departament[] = [];
  conciliatorList: UserData[] = [];

  selectedDate?: Date;
  selectedconciliator?: string;
  userId?: string;
  generalFilter: string = '';

  statusOrder!: number | null;
  dateOrder!: number | null;
  conciliatorOrder!: number | null;
  departamentOrder!: number | null;
  claimNumberOrder!: number | null;

  private AES = new AESEncryptDecryptService();

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() filters: EventEmitter<AudienceFilterModel> =
    new EventEmitter<AudienceFilterModel>();

  @ViewChild('op') overlayPanel!: OverlayPanel;
  private manualClose = false;

  constructor(
    private getAllDepartments: GetDepartmentsUseCase,
    private getAllConciliators: GetAllConciliatorsUseCase,
    private localStorageService: LocalStorageServiceBase,
    private messageService: MessageService,
    private filterService: FilterServiceService,
    private calendarTranslationService: CalendarTranslationService
  ) {}

  ngOnInit() {
    this.userId = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    this.getDepartments();
    this.getConciliators();
    const savedFilters = this.filterService.getFilters();
    if (savedFilters) {
      this.selectedconciliator = savedFilters.conciliatorId || '';
      this.selectedDate = savedFilters.fromDate || undefined;
      this.generalFilter = savedFilters.generalFilters || '';
      this.claimNumberOrder = savedFilters.claimNumberOrder || null;
      this.dateOrder = savedFilters.dateOrder || null;
      this.conciliatorOrder = savedFilters.conciliatorOrder || null;
      this.departamentOrder = savedFilters.departamentOrder || null;
      this.statusOrder = savedFilters.statusOrder || null;
    }
    this.calendarTranslationService.configureCalendarTranslations();
  }

  async getDepartments(): Promise<void> {
    const result: Departament[] | Failure =
      await this.getAllDepartments.execute();

    if (Array.isArray(result)) {
      this.departmentList = result;
    } else {
      this.errorMessage('error', 'Departamentos');
    }
  }

  async getConciliators(): Promise<void> {
    const result: UserData[] | Failure =
      await this.getAllConciliators.execute();

    if (Array.isArray(result)) {
      this.conciliatorList = result;
    } else {
      this.errorMessage('error', 'Conciliadores');
    }
  }

  private errorMessage(severity: string, name: string): void {
    this.messageService.add({
      severity: severity,
      summary: name,
      detail: `No se pudieron recuperar los ${name.toLocaleLowerCase()}`,
    });
  }

  orderSelect(typeOrder: string, order: number) {
    const current = this.getCurrentOrder(typeOrder);
    if (current === order) {
      this.clearAllOrders();
    } else {
      this.clearAllOrders();
      this.setOrder(typeOrder, order);
    }
  }

  clearAllOrders(): void {
    this.statusOrder = null;
    this.dateOrder = null;
    this.conciliatorOrder = null;
    this.departamentOrder = null;
    this.claimNumberOrder = null;
  }

  getCurrentOrder(type: string): number | null {
    switch (type) {
      case 'status':
        return this.statusOrder;
      case 'date':
        return this.dateOrder;
      case 'conciliator':
        return this.conciliatorOrder;
      case 'departament':
        return this.departamentOrder;
      case 'claimNumber':
        return this.claimNumberOrder;
      default:
        return null;
    }
  }

  setOrder(type: string, value: number | null): void {
    switch (type) {
      case 'status':
        this.statusOrder = value;
        break;
      case 'date':
        this.selectedDate = undefined;
        this.dateOrder = value;
        break;
      case 'conciliator':
        this.selectedconciliator = undefined;
        this.conciliatorOrder = value;
        break;
      case 'claimNumber':
        this.claimNumberOrder = value;
        break;
    }
  }

  hasFilters(): boolean {
    return (
      !!this.generalFilter ||
      !!this.selectedDate ||
      !!this.selectedconciliator ||
      !!this.statusOrder ||
      !!this.dateOrder ||
      !!this.conciliatorOrder ||
      !!this.departamentOrder ||
      !!this.claimNumberOrder
    );
  }

  cleanFilter(): void {
    this.selectedconciliator = undefined;
    this.selectedDate = undefined;
    this.generalFilter = '';
    this.clearAllOrders();
    this.filterService.clear();
    this.cancel.emit();
    this.overlayPanel.hide();
  }

  applyFilters(): void {
    this.filters.emit({
      conciliatorId: this.selectedconciliator,
      fromDate: this.selectedDate,
      generalFilters: this.generalFilter,
      statusOrder: this.statusOrder,
      dateOrder: this.dateOrder,
      conciliatorOrder: this.conciliatorOrder,
      departamentOrder: this.departamentOrder,
      claimNumberOrder: this.claimNumberOrder,
    });
    this.manualClose = true;
    this.overlayPanel.hide();
  }
}
